import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import LockIcon from '@material-ui/icons/LockOutlined';
import { Paper, Typography, Button, TextField, CircularProgress } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import SignUpStyles from '../../Styles/SignUpStyles';
import { Mixpanel } from '../../Config/mixpanel';
import { Context } from '../../Context';
import { Redirect } from 'react-router-dom';

class SignIn extends React.Component {
	constructor() {
		super();
		this.state = {
			email: '',
			password: ''
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleLogin = this.handleLogin.bind(this);
	}

	componentDidMount() {
		Mixpanel.track('Viewed page SignIn');
	}

	handleChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleLogin(event) {
		event.preventDefault();
		this.context.actions.login(this.state.email, this.state.password);
	}


	render() {
		const { classes } = this.props;

		if (this.context.state.token) {
			return (<Redirect to='/' />);
		}

		return (
			<div className={classes.main}>
				<Paper className={classes.paper}>
					<Avatar className={classes.avatar}>
						<LockIcon />
					</Avatar>
					<Typography component="h1" variant="h5" gutterBottom>
						Sign in to Vimma
        			</Typography>
					<form onSubmit={this.handleLogin}>
						<TextField
							label="Email address"
							value={this.state.email}
							onChange={this.handleChange}
							fullWidth
							margin="normal"
							variant="outlined"
							type="email"
							name="email"
							required={true}
						/>
						<TextField
							label="Password"
							value={this.state.password}
							onChange={this.handleChange}
							fullWidth
							margin="normal"
							variant="outlined"
							type="password"
							name="password"
							autoComplete="current-password"
							required={true}
						/>
						<div className={classes.wrapper}>
							<Button
								type="submit"
								fullWidth
								variant="contained"
								color="primary"
								className={classes.submit}
								disabled={this.context.state.loading}>
								Sign in
							</Button>
							{this.context.state.loading && <CircularProgress size={24} className={classes.buttonProgress} />}
						</div>
					</form>
					{this.context.state.error && (
						<Typography variant="subtitle1" className={classes.error}>
							{this.context.state.error}
						</Typography>
					)}
					<Typography variant="body1" className={classes.typography}>
						Don't have an account? Contact <a href="mailto:hello@vimma.co?Subject=I%20would%20like%20to%20sign%20up%20to%20Vimma%20as%20an%20advertiser!">hello@vimma.co</a> to sign up.
					</Typography>
				</Paper>
			</div >
		);
	}
}

SignIn.propTypes = {
	"classes": PropTypes.object.isRequired
};

SignIn.contextType = Context;

export default withStyles(SignUpStyles)(SignIn);
